import React from 'react'
import Stack from '@mui/material/Stack'
import { MerchantLogo } from '@mxenabled/mxui'
import { Recurrence } from '../../../core'

interface MerchantLogosRowProps {
  upcomingRecurrences: Recurrence[]
  maxLogos?: number
}

export const MerchantLogosRow: React.FC<MerchantLogosRowProps> = ({
  upcomingRecurrences,
  maxLogos = 3,
}) => {
  return (
    <Stack sx={{ flexDirection: 'row', gap: 4 }}>
      {upcomingRecurrences?.slice(0, maxLogos).map((recurrence, index) => (
        <MerchantLogo
          categoryGuid={recurrence.categoryGuid || ''}
          key={`${recurrence.categoryGuid}-${recurrence.merchantGuid}-${index}`}
          merchantGuid={recurrence.merchantGuid || ''}
        />
      ))}
    </Stack>
  )
}
